import { render } from "./MinSidebar.vue?vue&type=template&id=f0cf7344"
import script from "./MinSidebar.vue?vue&type=script&lang=js"
export * from "./MinSidebar.vue?vue&type=script&lang=js"

import "./MinSidebar.vue?vue&type=style&index=0&id=f0cf7344&lang=css"

import exportComponent from "/home/misha/Рабочий стол/demo-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__